import apiClient from './client';

/**
 * Fetch the currently active announcement.
 * Returns null if no announcement is active.
 */
export const getActiveAnnouncement = async () => {
  try {
    const response = await apiClient.get('/announcements/active');
    return response.data.announcement || null;
  } catch (error) {
    console.error('[Announcements] Failed to fetch active announcement:', error);
    return null;
  }
};

/**
 * Fetch all announcements for admin management.
 *
 * @param {object} options - Query options
 * @param {number} options.limit - Pagination limit
 * @param {number} options.offset - Pagination offset
 * @param {string} token - Clerk JWT token (required)
 */
export const getAnnouncements = async (options = {}, token) => {
  try {
    const params = new URLSearchParams();
    if (options.limit) params.append('limit', options.limit);
    if (options.offset) params.append('offset', options.offset);

    const headers = { Authorization: `Bearer ${token}` };
    const response = await apiClient.get(`/announcements?${params.toString()}`, { headers });
    return response.data;
  } catch (error) {
    console.error('[Announcements] Failed to fetch announcements:', error);
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      error: 'NETWORK_ERROR',
      message: 'Errore di connessione'
    };
  }
};

/**
 * Create an announcement (admin only).
 *
 * @param {object} payload
 * @param {string} token - Clerk JWT token (required)
 */
export const createAnnouncement = async (payload, token) => {
  try {
    const headers = { Authorization: `Bearer ${token}` };
    const response = await apiClient.post('/announcements', payload, { headers });
    return response.data;
  } catch (error) {
    console.error('[Announcements] Failed to create announcement:', error);
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      error: 'NETWORK_ERROR',
      message: 'Errore di connessione'
    };
  }
};

/**
 * Update an announcement (admin only).
 *
 * @param {number} announcementId
 * @param {object} payload
 * @param {string} token - Clerk JWT token (required)
 */
export const updateAnnouncement = async (announcementId, payload, token) => {
  try {
    const headers = { Authorization: `Bearer ${token}` };
    const response = await apiClient.patch(`/announcements/${announcementId}`, payload, { headers });
    return response.data;
  } catch (error) {
    console.error('[Announcements] Failed to update announcement:', error);
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      error: 'NETWORK_ERROR',
      message: 'Errore di connessione'
    };
  }
};

/**
 * Delete an announcement (admin only).
 *
 * @param {number} announcementId
 * @param {string} token - Clerk JWT token (required)
 */
export const deleteAnnouncement = async (announcementId, token) => {
  try {
    const headers = { Authorization: `Bearer ${token}` };
    const response = await apiClient.delete(`/announcements/${announcementId}`, { headers });
    return response.data;
  } catch (error) {
    console.error('[Announcements] Failed to delete announcement:', error);
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      error: 'NETWORK_ERROR',
      message: 'Errore di connessione'
    };
  }
};
